import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect, useState } from 'react';
import style from '../HeaderButtons.module.scss';
export const useIconWrapperStyle = headerColorScheme => {
  const $ = _c(3);
  const [headBarIconWrapperStyle, setHeadBarIconWrapperStyle] = useState(style.headerBar__iconwrapper);
  let t0;
  let t1;
  if ($[0] !== headerColorScheme) {
    t0 = () => {
      if (headerColorScheme === "" || headerColorScheme === "blackOnTransparent") {
        setHeadBarIconWrapperStyle(` ${style.headerBar__iconwrapper} ${style.headerBarWhite__iconwrapper}`);
      } else {
        if (headerColorScheme === "blackOnTransparentTwo") {
          setHeadBarIconWrapperStyle(` ${style.headerBar__iconwrapper} ${style.headerBarTrans__iconwrapper}`);
        } else {
          if (headerColorScheme === "blackOnTransparentThree") {
            setHeadBarIconWrapperStyle(` ${style.headerBar__iconwrapper} ${style.headerBarTrans__iconwrapper}`);
          } else {
            setHeadBarIconWrapperStyle(`${style.headerBar__iconwrapper}`);
          }
        }
      }
    };
    t1 = [headerColorScheme];
    $[0] = headerColorScheme;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useLayoutEffect(t0, t1);
  return headBarIconWrapperStyle;
};